import cx from 'classnames'
import { RawButton } from '@/components/Button'
import { Icon } from '@/components/Icon'
import { Tooltip } from '@/components/Tooltip'
import styles from './RoutingRequirements.module.css'

export interface RoutingRequirementsProps {
  isEmpty: boolean
  isSelected: boolean
  error?: string
  onPress: () => unknown
  testId?: string
}

/**
 * The qualifying requirements every candidate must meet, which open in the
 * inspector.
 */
export function RoutingRequirements({
  isEmpty,
  isSelected,
  error,
  onPress,
  testId,
}: RoutingRequirementsProps) {
  return (
    <RawButton
      className={cx(
        styles.root,
        isSelected && styles.selected,
        error && styles.invalid,
      )}
      aria-pressed={isSelected}
      onPress={onPress}
      testId={testId}
    >
      <span className={styles.icon}>
        <Icon name="legend-builder-requirements" size={20} aria-hidden="true" />
      </span>
      <span className={styles.content}>
        <span className={styles.title}>Qualifying requirements</span>
        <span className={styles.description}>
          {isEmpty
            ? 'There are no configured rules; every candidate will match.'
            : 'There are configured rules; every candidate must satisfy these to match.'}
          {!isSelected && ' Click to edit.'}
        </span>
      </span>
      {error ? (
        <Tooltip content={error}>
          <span className={styles.error}>
            <Icon name="status-alert" size={16} role="img" aria-label={error} />
          </span>
        </Tooltip>
      ) : (
        <Icon name="arrow" size={16} className={styles.chevron} />
      )}
    </RawButton>
  )
}
